// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/nylas/v1/nylas.proto (package fingertip.creator.nylas.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CompleteAuthRequest, CompleteAuthResponse, CompleteConnectorAuthRequest, CompleteConnectorAuthResponse, ConnectZoomAuthUrlRequest, ConnectZoomAuthUrlResponse, GenerateAuthUrlRequest, GenerateAuthUrlResponse, GetSiteAvailabilityByDayRequest, GetSiteAvailabilityByDayResponse, SynchronizeCalendarRequest, SynchronizeCalendarResponse } from "./nylas_pb.js";

/**
 * @generated from rpc fingertip.creator.nylas.v1.NylasService.GenerateAuthUrl
 */
export const generateAuthUrl = {
  localName: "generateAuthUrl",
  name: "GenerateAuthUrl",
  kind: MethodKind.Unary,
  I: GenerateAuthUrlRequest,
  O: GenerateAuthUrlResponse,
  service: {
    typeName: "fingertip.creator.nylas.v1.NylasService"
  }
};

/**
 * @generated from rpc fingertip.creator.nylas.v1.NylasService.CompleteAuth
 */
export const completeAuth = {
  localName: "completeAuth",
  name: "CompleteAuth",
  kind: MethodKind.Unary,
  I: CompleteAuthRequest,
  O: CompleteAuthResponse,
  service: {
    typeName: "fingertip.creator.nylas.v1.NylasService"
  }
};

/**
 * @generated from rpc fingertip.creator.nylas.v1.NylasService.GetSiteAvailabilityByDay
 */
export const getSiteAvailabilityByDay = {
  localName: "getSiteAvailabilityByDay",
  name: "GetSiteAvailabilityByDay",
  kind: MethodKind.Unary,
  I: GetSiteAvailabilityByDayRequest,
  O: GetSiteAvailabilityByDayResponse,
  service: {
    typeName: "fingertip.creator.nylas.v1.NylasService"
  }
};

/**
 * @generated from rpc fingertip.creator.nylas.v1.NylasService.ConnectZoomAuthUrl
 */
export const connectZoomAuthUrl = {
  localName: "connectZoomAuthUrl",
  name: "ConnectZoomAuthUrl",
  kind: MethodKind.Unary,
  I: ConnectZoomAuthUrlRequest,
  O: ConnectZoomAuthUrlResponse,
  service: {
    typeName: "fingertip.creator.nylas.v1.NylasService"
  }
};

/**
 * @generated from rpc fingertip.creator.nylas.v1.NylasService.CompleteConnectorAuth
 */
export const completeConnectorAuth = {
  localName: "completeConnectorAuth",
  name: "CompleteConnectorAuth",
  kind: MethodKind.Unary,
  I: CompleteConnectorAuthRequest,
  O: CompleteConnectorAuthResponse,
  service: {
    typeName: "fingertip.creator.nylas.v1.NylasService"
  }
};

/**
 * @generated from rpc fingertip.creator.nylas.v1.NylasService.SynchronizeCalendar
 */
export const synchronizeCalendar = {
  localName: "synchronizeCalendar",
  name: "SynchronizeCalendar",
  kind: MethodKind.Unary,
  I: SynchronizeCalendarRequest,
  O: SynchronizeCalendarResponse,
  service: {
    typeName: "fingertip.creator.nylas.v1.NylasService"
  }
};
